import React from 'react';
import {
  Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomPagination from '../../../components/forms/Pagination';

export type PosMappingImportRowError = {
  rowNumber: number;
  id?: number;
  franchiseName: string;
  source: string;
  target: string;
  mappingType: string;
  storeNumber: string | null;
};

interface PosMappingValidationTableProps {
  items: PosMappingImportRowError[];
  page: number;
  setPage: (p: number) => void;
  totalPages: number;
  pageSize: number;
}

const PosMappingValidationTable: React.FC<PosMappingValidationTableProps> = ({
  items, page, setPage, totalPages, pageSize,
}) => {
  const { t } = useTranslation('posMapping');

  const pagedItems = items.slice(page * pageSize, (page + 1) * pageSize);

  if (items.length === 0) {
    return (
      <Typography sx={{ py: 2, color: 'text.secondary', fontSize: '0.85rem' }}>
        {t('bulk.noValidationErrors')}
      </Typography>
    );
  }

  return (
    <>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontSize: '0.78rem', fontWeight: 600 }}>{t('bulk.colRowNumber')}</TableCell>
              <TableCell sx={{ fontSize: '0.78rem', fontWeight: 600 }}>{t('bulk.colSource')}</TableCell>
              <TableCell sx={{ fontSize: '0.78rem', fontWeight: 600 }}>{t('bulk.colTarget')}</TableCell>
              <TableCell sx={{ fontSize: '0.78rem', fontWeight: 600 }}>{t('bulk.colMappingType')}</TableCell>
              <TableCell sx={{ fontSize: '0.78rem', fontWeight: 600 }}>{t('bulk.colFranchiseName')}</TableCell>
              <TableCell sx={{ fontSize: '0.78rem', fontWeight: 600 }}>{t('bulk.colStoreNumber')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pagedItems.map((item, i) => (
              <TableRow key={i}>
                <TableCell sx={{ fontSize: '0.78rem' }}>{item.rowNumber ?? '—'}</TableCell>
                <TableCell sx={{ fontSize: '0.78rem' }}>{item.source ?? '—'}</TableCell>
                <TableCell sx={{ fontSize: '0.78rem' }}>{item.target ?? '—'}</TableCell>
                <TableCell sx={{ fontSize: '0.78rem' }}>{item.mappingType ?? '—'}</TableCell>
                <TableCell sx={{ fontSize: '0.78rem' }}>{item.franchiseName ?? '—'}</TableCell>
                <TableCell sx={{ fontSize: '0.78rem' }}>{item.storeNumber ?? '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {totalPages > 1 && (
        <CustomPagination
          page={page}
          setPage={setPage}
          maxPages={totalPages}
          breakpointForChangeDisplay={120000}
          useNoDataMessage={false}
        />
      )}
    </>
  );
};

export default PosMappingValidationTable;